import React from "react"
import _ from "lodash"

import ConfirmationModal from "components/modal/confirmation-modal"

type DeleteConfirmProps = {
  show: boolean
  close: Function
  confirm: Function
  rowNum: number
  code: string
}

const DeleteConfirmation = (props: DeleteConfirmProps) => {
  return (
    <ConfirmationModal
      height={100}
      width={600}
      contentHeight={50}
      show={props.show}
      toggleShow={props.close}
      title={"Delete Confirmation"}
      confirmText={"Delete"}
      message={""}
      confirmFunc={props.confirm}
      cancelFunc={props.close}
      confirmOnly={false}
      closeOnly={false}>
        {`Are you sure you want to delete Row #: ${props.rowNum}, Code: ${props.code}?  This will also delete the corresponding revenue/expense.`}
    </ConfirmationModal>
  )
}

export default DeleteConfirmation
